:host {
  display: block;

  ui-button {
    margin: 14px 0 0 20px;

    &:first-of-type {
      margin-left: 0;
    }
  }

  p {
    font-size: 14px;
    margin: 0;
  }

  .error {
    display: flex;
    color: $ui-red;
    font-size: 16px;
    line-height: 24px;
    margin: 0;
    font-weight: 600;
  }
}
